import { useState } from "react";
import MainLayoutHeader from "./mainlayoutheader";
import MainLayoutSidenav from "./mainlayoutsidenav";

import { Page } from "types/generic";
import { Redirect, Route, Router, Switch, useHistory } from "react-router";
import ModalSelector from "./modal-selector.component";
import { connect, useStore } from "react-redux";
import { useIntl } from "react-intl";
import { Dispatch } from "redux";
import { updateIsOpenPreferencesModal } from "redux/reducers/global/actions";
import PreferencesModalContentComponent from "./preferences-modal-content/preferences-modal-content.component";
import { useRequestStatusManager } from "utils/hooks/use-request-status-manager.hook";
import ToastRequestHandler from "components/adhoc/toast-request-handler";

type MainLayoutProps = {
    pages: Page[];
    applications: any;
    isOpenPreferencesModal: boolean;
};

const MainLayout = ({
    pages,
    applications,
    isOpenPreferencesModal,
}: MainLayoutProps) => {
    const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
    const [currentPageId, setCurrentPageId] = useState(
        pages.length > 0 ? pages[0].id : "default"
    );

    const history = useHistory();
    const store = useStore();
    const intl = useIntl();

    const {
        allContentIsReady,
        errorList,
        success,
        removeAllData,
        subscribeContent,
        unsubscribeContent,
        setError,
    } = useRequestStatusManager();

    const contentName = "preferencesModal";

    const getSelectedPage = () => {
        for (let index in pages) {
            const currentPage = pages[index];
            if (currentPage.content && currentPage.id === currentPageId) {
                return currentPage.content();
            }
        }
    };

    const generateRoutesForPages = () => {
        let currentPath: string[] = history.location.pathname
            .split("/")
            .splice(1)
            .filter((path) => path !== "");
        let layoutRoute: string = currentPath[0];

        console.log(layoutRoute);
        console.log(currentPath);

        if (currentPath.length < 2 && pages.length > 0) {
            console.log(currentPageId);
            history.replace(`/${layoutRoute}/${currentPageId}/`);
        }

        return (
            <Switch>
                {pages.map((page: Page) => {
                    return (
                        <Route
                            path={"/:layout/" + page.id}
                            render={() => {
                                if (page.content) {
                                    return page.content();
                                }
                            }}
                            key={`page_${page.id}`}
                        />
                    );
                })}
                <Redirect from="/administration/*" to="/administration/" />
            </Switch>
        );
    };

    const generateMainLayoutClass = () => {
        if (isSidebarExpanded) {
            return "l-main-layout --expanded";
        } else {
            return "l-main-layout";
        }
    };

    const updateModalVisibility = (): void => {
        store.dispatch(updateIsOpenPreferencesModal(false));
    };

    return (
        <div className={generateMainLayoutClass()}>
            <div className="l-main-layout__header">
                <MainLayoutHeader applications={applications} />
            </div>
            <div className="l-main-layout__sidenav">
                <div className="l-main-layout__sidenav-container">
                    <MainLayoutSidenav
                        pages={pages}
                        currentSelectedPage={currentPageId}
                        setCurrentSelectedPage={setCurrentPageId}
                        showHierarchy={false}
                        isExpanded={isSidebarExpanded}
                    />
                </div>
                <div
                    className="l-main-layout__expand-arrow"
                    onClick={() => setIsSidebarExpanded(!isSidebarExpanded)}
                />
            </div>
            <div className="l-main-layout__content">
                {generateRoutesForPages()}
            </div>
            {isOpenPreferencesModal && (
                <div className="c-preferences-modal__container">
                    <ModalSelector
                        children={
                            <PreferencesModalContentComponent
                                updateModalVisibility={updateModalVisibility}
                                contentName={contentName}
                                subscribeContent={subscribeContent}
                                unsubscribeContent={unsubscribeContent}
                                setError={setError}
                            />
                        }
                        title={intl.formatMessage({
                            id: "app.components.preferences.preferenceSettings",
                        })}
                        updateModalVisibility={updateModalVisibility}
                        isOpenModal={() => {}}
                    />
                </div>
            )}
            <ToastRequestHandler
                allContentIsReady={allContentIsReady}
                closeToast={removeAllData}
                errorList={errorList}
                success={success}
            />
        </div>
    );
};

const mapStateToProps = (state: any) => {
    return { isOpenPreferencesModal: state.app.isOpenPreferencesModal };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);
